module.exports = __webpack_public_path__ + "img/logarithmic_nature2.9900f3c5.jpg";